import { render, staticRenderFns } from "./DataRequestConfirmationModal.vue?vue&type=template&id=3ca29b04&"
import script from "./DataRequestConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./DataRequestConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports